import { render, staticRenderFns } from "./EditVenueLoader.vue?vue&type=template&id=3e7bfe32"
import script from "./EditVenueLoader.vue?vue&type=script&lang=ts"
export * from "./EditVenueLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports